module.exports = __webpack_public_path__ + "static/FlowerCake1-a69a0e6f84a78f1427dc26b2ac724021.png";